import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTokenExpiration } from 'repositories/usecases/use.auth'
import { useGetSettings } from 'repositories/usecases/use.webs'

import routesPub from 'navigations/routes_pub'
import routesPvt from 'navigations/routes_pvt'

export const useLayoutBloC = () => {
  useTokenExpiration()

  const isAuthenticated = useSelector((state) => state.auth?.isAuth)
  const authinfo = useSelector((state) => state.auth?.info)

  const shouldSkipFetchSettings = useMemo(
    () => !isAuthenticated,
    [isAuthenticated]
  )

  const [settings] = useGetSettings({ skip: shouldSkipFetchSettings })
  let routes = routesPvt({
    summon: settings?.data?.summon ?? false,
    telegram: settings?.data?.telegram?.enable ?? false,
  })
  if (authinfo.profile.email === settings.dashboardAccount) {
    routes = routesPub({ summon: settings?.data?.summon ?? false })
  }

  const mqttUsername = settings.data?.mqtt?.username
  const mqttPassword = settings.data?.mqtt?.password
  return [
    {
      isLoading: settings.isLoading,
      isSuccess: settings.isSuccess,
      isError: settings.isError,
      error: settings.error,
      isAuthenticated,
      summon: settings.data?.summon ?? false,
      attendance: settings.data?.attendance?.enable ?? false,
      telegram: settings.data?.telegram?.enable ?? false,
      dashboardAccount: settings.data?.dashboardAccount ?? '',
      utm: settings.data?.utm ?? false,
      mqtt: {
        broker: getMqttBroker(),
        option: {
          keepalive: 30,
          reconnectPeriod: 1000,
          connectTimeout: 30 * 1000,
          clientId: `webapp_${
            authinfo?.id?.slice(2, 8) ?? Math.random().toString(16).slice(2, 10)
          }`,
          clean: false,
          username: mqttUsername,
          password: mqttPassword,
          resubscribe: true,
          protocolVersion: 4,
        },
      },
      routes,
    },
  ]
}

function getMqttBroker() {
  const url =
    process.env['REACT_APP_API_v4_MQTT_BROKER'] ??
    process.env['REACT_APP_API_v4_BASEURL'] ??
    `${window.location.origin}`
  try {
    const parsedUrl = new URL(url)
    const protocolType = parsedUrl.protocol.replace(':', '')
    const mqttProto = protocolType === 'https' ? 'wss' : 'ws'
    parsedUrl.protocol = mqttProto
    parsedUrl.pathname = process.env['REACT_APP_API_v4_MQTT_BROKER']
      ? ''
      : '/mqtt'
    return parsedUrl.toString()
  } catch (error) {
    console.error('Invalid URL:', error)
    return url // Return original if URL is invalid
  }
}
